export default __webpack_public_path__ + "static/media/chatapp.a0b1b6a5.png";